export const PASSWORD_MODE = {
	Change: "change",
	Changed: "changed",
} as const;

export type PasswordChangeMode = typeof PASSWORD_MODE.Change;
